export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatCurrency = (value) => {
    if (value === null || value === undefined) return '';
    
    // Check if the value is already in the format "xy.zk"
    const isFormatted = /^\d+\.\d{2}$/.test(value.toString());
    
    if (isFormatted) {
        return `${value} €`;
    } else {
        // Format the number to have two decimal places and then add the euro symbol
        return `${parseFloat(value).toFixed(2)} €`;
    }
};

  